import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

const SelectOptions = ({ label, id, value, onChange, options }) => {
  return (
    <FormControl required fullWidth>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        required
        labelId={`${id}-label`}
        id={id}
        value={value}
        label={label}
        onChange={onChange}>
        {options?.map((item) => (
          <MenuItem key={item} value={item}>
            {item}
          </MenuItem>
        ))}
      </Select>{" "}
      <FormHelperText>Required *</FormHelperText>
    </FormControl>
  );
};

export default SelectOptions;
